export default class Validator {
  constructor(rules) {
    this.rules = rules; // { field: [ { test: (v)=>true, message: '' } ] }
  }

  validate(values) {
    const errors = {};
    for (const [field, checks] of Object.entries(this.rules)) {
      const value = (values[field] ?? '').toString().trim();
      for (const rule of checks) {
        if (!rule.test(value, values)) {
          errors[field] = rule.message;
          break;
        }
      }
    }
    return errors;
  }

  static required(msg = 'This field is required') {
    return { test: (v) => v.length > 0, message: msg };
  }
  static email(msg = 'Enter a valid email') {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return { test: (v) => re.test(v), message: msg };
  }
  static phone(msg = 'Use digits, +, space or dash') {
    const re = /^[\d+\-\s]{6,}$/;
    return { test: (v) => re.test(v), message: msg };
  }
  static min(n, msg) {
    return { test: (v) => v.length >= n, message: msg || `Minimum ${n} characters` };
  }
}
